import { Action, AnyAction, Reducer } from 'redux';

export interface CompanyAction<T = any> extends Action<T> {
    companyId: string;
}

function isCompanyAction<T = any>(action: Action): action is CompanyAction<T> {
    return 'companyId' in action && typeof action['companyId'] === 'string';
}

export interface CompanyMap<S> {
    [companyId: string]: S;
}

export const withCompany = <S, A extends CompanyAction>(
    reducer: (subState: S | undefined, action: A) => S,
): Reducer<CompanyMap<S>, AnyAction> => (
    state: CompanyMap<S> = {},
    action: Action,
) => {
    if (isCompanyAction(action)) {
        return {
            ...state,
            [action.companyId]: reducer(state[action.companyId], action as A),
        };
    }
    return state;
};
